import { useState } from 'react';
import { CSVColumnDefinition } from '../models/CSVColumnDefinition';

export function useCSVExport(columnDefinitions: CSVColumnDefinition<any>[]) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [exportData, setExportData] = useState<any[]>([]);
  const [defaultFilename, setDefaultFilename] = useState<string>('export');

  const openExportModal = (data: any[], filename?: string) => {
    setExportData(data);
    setDefaultFilename(filename || 'export');
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setExportData([]);
  };

  return {
    openExportModal,
    isModalOpen,
    exportData,
    defaultFilename,
    columnDefinitions,
    closeModal
  };
}